<ng-container *ngIf="generalSettingsData">
  <button class="no-style search" (click)="openSearch()">
    <mat-icon [svgIcon]="'search'" class="square-icon search-icon"></mat-icon>
  </button>

  <button class="no-style notifications" (click)="openNotifications()">
    <mat-icon [svgIcon]="'bell'" class="notifications-icon"></mat-icon>
    <span class="counter" *ngIf="countOfUnreadNotifications > 0">{{countOfUnreadNotifications}}</span>
  </button>

  <div class="separator"></div>
  
  <ng-container *ngIf="localizationService.availableCultures.length > 0">
    <button [matMenuTriggerFor]="langugeMenu" class="no-style my-links culture-select">
      {{localizationService.getCurrentShortCultureName()}}
      <mat-icon [svgIcon]="'arrow-down'" class="square-icon dropdown-arrow"></mat-icon>
    </button>
    <mat-menu #langugeMenu="matMenu" class="my-links-dropdown">
      <button *ngFor="let item of localizationService.availableCultures" mat-menu-item value="{{item.code}}" 
        (click)="setCurrentCultureCode(item.code)">{{item.name}}</button>
    </mat-menu>
  </ng-container>

  <div class="separator separator-second"></div>

  <button [matMenuTriggerFor]="menu" class="no-style my-links">
    {{generalSettingsData.portalGeneralSettingsData.mylinksTitleValue}}
    <mat-icon [svgIcon]="'arrow-down'" class="square-icon dropdown-arrow"></mat-icon>
  </button>
  <mat-menu #menu="matMenu" class="my-links-dropdown">
    <a mat-menu-item *ngFor="let link of generalSettingsData.portalGeneralSettingsData.myLinksListValue" href="{{link.url}}" target="_blank">{{link.name}}</a>
  </mat-menu>
</ng-container>

<ng-container *ngIf="!generalSettingsData">
  <div class="no-style search" aria-hidden="true" >
    <mat-icon [svgIcon]="'search'" class="square-icon search-icon"></mat-icon>
  </div>

  <div class="separator"></div>

  <div class="no-style notifications" aria-hidden="true" >
    <mat-icon [svgIcon]="'bell'" class="notifications-icon"></mat-icon>
    <app-skeleton class="notification-counter-skeleton" [height]="15" [width]="13" [borderRadius]="18"/>
  </div>

  <div class="separator separator-first"></div>

  <div class="no-style my-links culture-select" aria-hidden="true">
    <app-skeleton [symbolsCount]="2" type="text"/>
    <mat-icon [svgIcon]="'arrow-down'" class="square-icon dropdown-arrow"></mat-icon>
  </div>

  <div class="separator separator-second"></div>

  <div class="no-style my-links" aria-hidden="true" >
    <app-skeleton [symbolsCount]="18" type="text"/>
    <mat-icon [svgIcon]="'arrow-down'" class="square-icon dropdown-arrow"></mat-icon>
  </div>
</ng-container>